import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Clock } from 'lucide-react';

const TimePickerInput = ({ field, form, ...props }) => {
  const { name, value } = field;
  const { setFieldValue, setFieldTouched } = form;
  const [time, setTime] = useState(null);
  const datepickerRef = useRef(null);

  useEffect(() => {
    if (value) {
      const [hours, minutes] = value.split(':');
      const date = new Date();
      date.setHours(parseInt(hours, 10));
      date.setMinutes(parseInt(minutes, 10));
      date.setSeconds(0);
      setTime(date);
    } else {
      setTime(null);
    }
  }, [value]);

  const handleChange = (date) => {
    if (date) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const formatted = `${hours}:${minutes}`;
      setFieldValue(name, formatted);
    } else {
      setFieldValue(name, '');
    }
  };

  const handleBlur = () => {
    setFieldTouched(name, true);
  };

  const openCalendar = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(true);
    }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
      <DatePicker
        ref={datepickerRef}
        selected={time}
        onChange={handleChange}
        onBlur={handleBlur}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={1}
        timeCaption="Time"
        dateFormat="HH:mm"
        placeholderText={props.placeholder}
        className="form-control"
      />
      <Clock
        size={20}
        onClick={openCalendar}
        style={{
          position: 'absolute',
          left: 70,
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          color: '#555',
          pointerEvents: 'auto',
        }}
        title="Open time picker"
      />
    </div>
  );
};

export default TimePickerInput;
